import { datadogRum } from '@datadog/browser-rum';
import UiConfig from 'constants/ui-config';

if (UiConfig.RUM_ENABLED) {
    datadogRum.init({
        applicationId: process.env.RUM_APP_ID,
        clientToken: process.env.RUM_CLIENT_TOKEN,
        site: 'datadoghq.com',
        service: 'jaus',
        env: process.env.RUM_ENV,
        // Specify a version number to identify the deployed version of your application in Datadog
        version: UiConfig.VERSION,
        sampleRate: 100,
        trackInteractions: true,
        defaultPrivacyLevel: 'allow',
        allowedTracingOrigins: [process.env.RUM_TRACING_ORIGIN]
    });

    datadogRum.startSessionReplayRecording();
}

import './yup-extensions';

import { Provider } from 'react-redux';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import configureStore, { history } from './configure-store';
import { MuiThemeProvider, createTheme } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';

const theme = createTheme({
    typography: {
        useNextVariants: true
    },
    palette: {
        success: {
            light: '#81c784',
            main: '#4caf50',
            dark: '#388e3c',
            contrastText: 'rgba(0, 0, 0, 0.87)'
        },
        warning: {
            light: '#ffb74d',
            main: '#ff9800',
            dark: '#f57c00',
            contrastText: 'rgba(0, 0, 0, 0.87)'
        }
    }
});

const store = configureStore();

ReactDOM.render(
    <React.Fragment>
        <CssBaseline/>
        <Provider store={store}>
            <MuiThemeProvider theme={theme}>
                <App history={history} />
            </MuiThemeProvider>
        </Provider>
    </React.Fragment>,
    document.getElementById('react-root')
);

